import { Injectable}    from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot,Router } from '@angular/router';
import { Observable }    from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {  
  constructor(private router: Router) { }
  projectId:any;
  canDeactivate(component: CanComponentDeactivate, 
           route: ActivatedRouteSnapshot, 
           state: RouterStateSnapshot,
           nextState: RouterStateSnapshot) {
     this.projectId = route.params.projectId; 
     let url: string = state.url;
     let nextStateUrl = nextState.url;
     let ignoreRoutesName = ['login','/login','/acp/'+this.projectId];
     return component.canDeactivate() || (ignoreRoutesName.includes(nextStateUrl))
        ? true  
        : confirm(  
            "You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes."  
          );   
  }
}